import React, { useCallback } from 'react';
import { useUserInformationContext } from 'contexts/userContext';
import AuthenticatedLayoutScene from './authenticated-layout-scene';
import useAuthenticatedLayout from './use-authenticated-layout';
import { AiUsageModal } from '../../components/ai-usage/ai-usage-modal';
import { logout } from 'services/auth';

type AuthenticatedLayoutProps = {
  children: React.ReactElement;
};

const AuthenticatedLayout = ({ children }: AuthenticatedLayoutProps) => {
  const {
    t,
    i18n,
    anchorEl,
    setAnchorEl,
    history,
    userIsTitleAdmin,
    location,
    userLetters,
    agencySelected,
    selectAgency,
    templateAnchorEl,
    setTemplateAnchorEl,
    setLanguage,
  } = useAuthenticatedLayout();

  const [aiUsageEmail, setAiUsageEmail] = React.useState<string | null>(null);

  const { currentUser } = useUserInformationContext();

  const isMenuOpen = Boolean(anchorEl);
  const currentLanguageCode = i18n.language || window.localStorage.i18nextLng || 'en';
  const handleRoute = (path: string) => history.push(path);

  const handleNavigateProfile = () => window.open(`/contacts/${currentUser?._id}`);

  const handleNavigateTermsOfService = () => history.push('/terms-of-service');

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(event.currentTarget);

  const handleTemplateClick = (event?: React.MouseEvent<HTMLButtonElement>) => {
    event?.stopPropagation();
    const element = event?.currentTarget;
    setTemplateAnchorEl(element ?? null);
  };

  const handleLanguage = (newLanguage: string) => {
    i18n.changeLanguage(newLanguage);
    setLanguage(newLanguage);
  };

  const handleOpenAiUsage = (email: string | null) => {
    setAiUsageEmail(email ?? null);
  };

  const handleLogout = async () => {
    await logout();
  };
  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, [setAnchorEl]);

  return (
    <AuthenticatedLayoutScene
      t={t}
      agencySelected={agencySelected}
      selectAgency={selectAgency}
      location={location}
      userIsTitleAdmin={userIsTitleAdmin}
      currentLanguageCode={currentLanguageCode}
      userLetters={userLetters}
      anchorEl={anchorEl}
      isMenuOpen={isMenuOpen}
      handleRoute={handleRoute}
      handleLanguage={handleLanguage}
      handleProfileMenuOpen={handleProfileMenuOpen}
      handleNavigateProfile={handleNavigateProfile}
      handleNavigateTermsOfService={handleNavigateTermsOfService}
      handleLogout={handleLogout}
      handleClose={handleClose}
      handleTemplateClick={handleTemplateClick}
      templateAnchorEl={templateAnchorEl}
      handleOpenAiUsage={handleOpenAiUsage}
    >
      <>
        {React.cloneElement(children, { agencySelected })}

        {/* AiUsageModal at parent level to use correct state */}
        <AiUsageModal email={aiUsageEmail} onClose={() => setAiUsageEmail(null)} />
      </>
    </AuthenticatedLayoutScene>
  );
};

export default AuthenticatedLayout;
